/**
 * ONE predicate, three call sites (nav visibility, route guard, action gating) — Phase 7 calls it.
 * A second implementation never exists. `Permission` is the handed union from `client.ts`.
 *
 * The three SPA-only `scenarios:*` stand-ins (`runs:read`, `runs:write`, `tenant:admin`) are gone:
 * the API publishes `scenarios:read|write|promote` in `bootstrap.user.permissions` (SN-D13, SN-D16),
 * so a scenario screen asks for the real permission and nothing else.
 */
import type { Permission } from "../api/client";

export type PermissionRule =
  "none" | Permission | { anyOf: Permission[] } | { allOf: Permission[] };

/** True when `held` satisfies `rule`. `'none'` is always satisfied (no permission required). */
export function hasPermission(held: readonly string[], rule: PermissionRule): boolean {
  if (rule === "none") return true;
  if (typeof rule === "string") return held.includes(rule);
  if ("anyOf" in rule) return rule.anyOf.some((p) => held.includes(p));
  return rule.allOf.every((p) => held.includes(p));
}
